export const environment = {
  production: false,
  apiUrl: 'https://apistaging.calact.org'
};